(function () {

  'use strict';

  /**
   * @author Ronald Nicholls | Chester Rivas
   * @ngdoc directive
   * @description
   * @name uteRule
   * @class ute-ui
   * @memberOf ute-ui
   */
  angular.module('ute.ui')

    .constant('restive', $.restive)

    .directive('uteRestive', ["restive", function (restive) {

      return {
        restrict: 'AE',
        scope: {
          bandwidthSource: '@',
          speed: '@'
        },
        replace: false,
        controller: ["$scope", "$element", function ($scope, $element) {

          // var testBandwidth = function () {
          //
          //   // Let's initialize the primitives
          //   var startTime,
          //     endTime,
          //     fileSize;
          //
          //   // Set up the AJAX to perform
          //   var xhr = new XMLHttpRequest();
          //
          //   // Rig the call-back... THE important part
          //   xhr.onreadystatechange = function () {
          //
          //     // we only need to know when the request has completed
          //     if (xhr.readyState === 4 && xhr.status === 200) {
          //
          //       // Here we stop the timer & register end time
          //       endTime = (new Date()).getTime();
          //
          //       // Also, calculate the file-size which has transferred
          //       fileSize = xhr.responseText.length;
          //
          //       // Calculate the connection-speed
          //       var speed = (fileSize * 8) / ((endTime - startTime) / 1000) / 1024;
          //
          //       // Report the result
          //       $scope.speed = $scope.speed || speed;
          //       setAttributes();
          //
          //     }
          //
          //   };
          //
          //   //Start the timer
          //   startTime = (new Date()).getTime();
          //
          //   xhr.open('GET', 'https://wp-daddy.com/files/uploads/2015/02/z60.jpg', true);
          //   xhr.send();
          //
          // };

          //if (angular.isDefined($scope.bandwidthSource)) {
          //
          //  var req = new XMLHttpRequest();
          //  req.open('GET', $scope.bandwidthSource, true);
          //
          //  req.onreadystatechange = function (oEvent) {
          //
          //    if (req.readyState === 4) {
          //
          //      if (req.status === 200) {
          //
          //        var headers = req.getAllResponseHeaders().toLowerCase();
          //
          //        // Find and retrieve "Bandwidth" value
          //        var arrHeaders = headers.split('\r\n');
          //
          //        var bandwidth = arrHeaders[arrHeaders.indexOf('bandwidth: fast')];
          //
          //        if (_.isUndefined(bandwidth)) {
          //          testBandwidth();
          //        } else {
          //          bandwidth = bandwidth.split(': ')[1];
          //          $scope.speed = $scope.speed || bandwidth;
          //          setAttributes();
          //        }
          //
          //      } else {
          //        testBandwidth();
          //      }
          //
          //    }
          //
          //  };
          //
          //  req.send(null);
          //
          //} else {
          //
          //  $scope.bandwidthSource = 'fast';
          //
          //}

          //testBandwidth();


          var breakClass,
            bandwidth = null,
            deviceSize,
            selector = $($element),
            classes = ['xs', 'sm', 'md', 'lg', 'xl', '2k', '4k', '8k'],
            setAttributes = function () {
              _.each(classes, function (value) {
                if (selector.attr('class').indexOf(value) > -1) {
                  deviceSize = value;
                }
              });

              breakClass = restive.isPhone() ? 'xs' : deviceSize;
              selector.attr('ute-device-orientation', restive.getOrientation())
                .attr('ute-device-platform', restive.getPlatform())
                .attr('ute-device-formfactor', restive.getFormFactor())
                .attr('ute-device-mobile', restive.isMobile())
                .attr('ute-device-resolution', restive.getResolution())
                .attr('ute-device-bandwidth', 'fast')
                .attr('ute-device-size', breakClass);
            };

          restive.startMulti();

          /*jshint camelcase: false */
          selector.restive({
            breakpoints: ['640', '720', '960', '1024', '1280', '1920', '3840', '7680'],
            classes: ['xs', 'sm', 'md', 'lg', 'xl', '2k', '4k', '8k'],
            force_dip: true,
            onRotate: function () {
              selector.attr('ute-device-orientation', restive.getOrientation());
            },
            onAddClass: function () {
              setAttributes();
            }
          });

          selector.restive({
            breakpoints: ['800'],
            classes: ['xs'],
            formfactor: 'phone',
            force_dip: true,
            onRotate: function () {
              selector.attr('ute-device-orientation', restive.getOrientation());
            },
            onAddClass: function () {
              setAttributes();
            }
          });

          restive.endMulti();

          setAttributes();

        }]

      };

    }]);

})();
